import { Stack, StackProps, Typography, TypographyProps } from "@mui/material";
import ButtonWithPermissions, { ButtonWithPermissionsProps } from "components/buttons/ButtonWithPermissions";
import { ReactNode, useMemo } from "react";

interface PageHeaderProps {
  containerProps?: StackProps;
  title: ReactNode;
  subTitle?: ReactNode;
  titleProps?: TypographyProps;
  mainButtonProps?: ButtonWithPermissionsProps | ButtonWithPermissionsProps[];
  CustomButtons?: ReactNode;
}

const PageHeader = ({
  containerProps,
  title,
  subTitle,
  titleProps,
  mainButtonProps,
  CustomButtons,
}: PageHeaderProps) => {
  const mainButtonPropsArr = useMemo(() => {
    if (!mainButtonProps) return mainButtonProps;
    if (Array.isArray(mainButtonProps)) return mainButtonProps;
    return [mainButtonProps];
  }, [mainButtonProps]);

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems={{ xs: "flex-start", md: "center" }}
      justifyContent='space-between'
      spacing={2}
      sx={{ mb: 2.5 }}
      {...containerProps}>
      <Stack spacing={0.5}>
        <Typography
          variant='h28'
          {...titleProps}>
          {title}
        </Typography>
        {!!subTitle && <Typography color='text.secondary'>{subTitle}</Typography>}
      </Stack>
      <Stack
        direction='row'
        spacing={1.5}>
        {!!CustomButtons && CustomButtons}
        {mainButtonPropsArr?.map((mainButtonPropsItem, index) => (
          <ButtonWithPermissions
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            {...mainButtonPropsItem}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default PageHeader;
